import { useEffect } from 'react';

import type { FormatType } from '@revelio/replots';

import { useCurrencyPreference } from '../../../../../shared/user-preferences/hooks/useCurrencyPreference';
import { usePageExport } from '../chart-menu/PageExportProvider';
import type { ColumnMetaMap } from './utils/convertSeriesToTableData';

type TableChartExportMetaProps = {
  chartId: string;
  enabled: boolean;
  columnMetaMap: ColumnMetaMap | undefined;
  plotFormat: FormatType | undefined;
};

export const TableChartExportMeta = ({
  chartId,
  enabled,
  columnMetaMap,
  plotFormat,
}: TableChartExportMetaProps) => {
  const { updateChartExportInfo } = usePageExport();
  const { code: tableCurrencyCode } = useCurrencyPreference();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    updateChartExportInfo(chartId, {
      tableColumnMetaMap: columnMetaMap,
      tablePlotFormat: plotFormat,
      tableCurrencyCode,
    });
  }, [
    chartId,
    enabled,
    columnMetaMap,
    plotFormat,
    tableCurrencyCode,
    updateChartExportInfo,
  ]);

  return null;
};
